var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"heading":`${_vm.$t('actions.create')} ${_vm.$tc('models.lesson')} ${
      _vm.lesson.courseModule !== null
        ? _vm.$t('misc.on') + ' ' + _vm.getTranslation(_vm.lesson.courseModule.name)
        : ''
    }`}},[(_vm.lesson !== null)?_c('lesson-form-v2',{attrs:{"lesson":_vm.lesson},on:{"submit":_vm.handleSubmit,"cancel":_vm.handleCancel}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }